import { getUserLang } from '@mb/lib/i18n';

export const INFO_USER_LOCALSTORAGE = 'mage-cache-storage';

export enum StorageLabelsEnum {
  GRID_MODE = 'gridMode',
  INFO_MODE = 'infoMode',
  COLUMN_NUMBER = 'columnNumber',
}

export const getUserAttributes = () => {
  return (
    JSON.parse(localStorage.getItem(INFO_USER_LOCALSTORAGE) || '{}')
      ?.customer || {}
  );
};

export const getCartItems = () => {
  return (
    JSON.parse(localStorage.getItem(INFO_USER_LOCALSTORAGE) || '{}')?.cart
      ?.items || []
  );
};

export const getPayloadLang = () => {
  const storageLang = getUserLang();
  const configLang =
    typeof ENVIRONMENT_REGION !== 'undefined' ? ENVIRONMENT_REGION : 'US';

  return `${storageLang}-${configLang}`;
};
